import React from 'react';
import PropTypes from 'prop-types';
import { selectSystemProps, useViewport } from '@telus-uds/components-base';
import styled from 'styled-components';
import { viewports } from '@telus-uds/system-constants';
import SplashButton from './SplashButton/SplashButton';
import SplashButtonWithDetails from './SplashButtonWithDetails/SplashButtonWithDetails';
import videoText from '../../Video/videoText';
import { htmlAttrs } from '../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
const [selectProps, selectedSystemPropTypes] = selectSystemProps([htmlAttrs]);
const SplashBackground = /*#__PURE__*/styled.div.withConfig({
  displayName: "VideoSplash__SplashBackground",
  componentId: "components-web__sc-1ejxt6-0"
})(_ref => {
  let {
    videoPoster
  } = _ref;
  return {
    backgroundImage: `url(${videoPoster})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    // fixes vertical alignment on IE 11
    cursor: 'pointer'
  };
});
const VideoSplash = _ref2 => {
  let {
    poster,
    videoLength,
    simpleMode,
    copy = 'en',
    onClick,
    ...rest
  } = _ref2;
  const viewport = useViewport();
  const showDetails = !simpleMode && viewport !== viewports.xs;
  const label = videoText[copy].watch;
  return /*#__PURE__*/_jsx(SplashBackground, {
    ...selectProps(rest),
    onClick: onClick,
    videoPoster: poster,
    children: showDetails ? /*#__PURE__*/_jsx(SplashButtonWithDetails, {
      videoLength: videoLength,
      copy: copy,
      label: label
    }) : /*#__PURE__*/_jsx(SplashButton, {
      videoLength: videoLength,
      copy: copy
    })
  });
};
VideoSplash.propTypes = {
  ...selectedSystemPropTypes,
  onClick: PropTypes.func,
  poster: PropTypes.string,
  videoLength: PropTypes.number.isRequired,
  simpleMode: PropTypes.bool,
  copy: PropTypes.oneOf(['en', 'fr'])
};
export default VideoSplash;